// ** React Imports
import { useState, useEffect, useCallback } from 'react';

// ** Third Party Components
import { ArrowLeft, ArrowRight, XCircle, DownloadCloud } from 'react-feather';

// ** Reactstrap Imports
import { Label, Row, Col, Button, Input } from 'reactstrap';
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { formatVideoFromYoutube } from '@utils';

import '@styles/react/libs/editor/editor.scss';
import FileUploaderSingle from '@components/input/FileUploaderSingle';
import api from '../../../../../graphql/api';

const _data = new Map();

const EditorComponent = ({ content, idx, handleDelete, handleOnChange }) => {
  const blocksFromHtml = convertFromHTML(content);
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
        blocksFromHtml.entityMap
      )
    )
  );

  const handleChanges = (_value) => {
    setEditorState(_value);
    const draft = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    handleOnChange(`${idx}_html`, {
      content: draft,
      type: 'html'
    });
  };

  // useEffect(() => {
  //   EditorState.createWithContent(ContentState.createFromText(content));
  // }, [content]);

  return (
    <Row className="mb-5">
      <Col md={10}>
        <Editor
          editorState={editorState}
          onEditorStateChange={(data) => {
            handleChanges(data);
          }}
        />
      </Col>
      <Col md={2}>
        <Button
          type="button"
          color="#7367F0"
          style={{
            background: '#7367F0',
            padding: 10
          }}
          onClick={() => handleDelete(`${idx}_html`)}
        >
          <XCircle
            enableBackground="#7367F0"
            fill="#7367F0"
            color="white"
            style={{
              cursor: 'pointer'
            }}
          />
        </Button>
      </Col>
    </Row>
  );
};

const VideoComponent = ({ content, idx, handleDelete, handleOnChange }) => {
  const [value, setValue] = useState(content || '');
  const [videoPreview, setVideoPreview] = useState(() => {
    return formatVideoFromYoutube(content || '');
  });

  const handleChanges = (_value) => {
    setValue(_value);
    setVideoPreview(formatVideoFromYoutube(_value) || '');
    handleOnChange(`${idx}_video`, {
      content: _value,
      type: 'video'
    });
  };

  useEffect(() => {
    setValue(content);
  }, [content]);

  return (
    <Row className="mb-5">
      <Col md={3}>
        <Label htmlFor="video" className="label-road-input">
          Link del video
        </Label>
        <Input
          id="video"
          name="videoUri"
          placeholder="https://youtube.com/..."
          onChange={(e) => {
            handleChanges(e.target.value);
          }}
          value={value}
          required
        />
      </Col>
      <Col md={4}>
        {(videoPreview !== '' &&
          videoPreview.startsWith('https://youtube.com')) ||
        videoPreview.startsWith('https://www.youtube.com') ? (
          <iframe
            width="366"
            height="198"
            src={`${videoPreview}?controls=0`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <div
            style={{
              width: 366,
              height: 198,
              background: '#F7F7F7'
            }}
            className="position-relative"
          >
            <span
              className="position-absolute fw-bolder top-50 start-50 translate-middle"
              style={{
                color: '#6D6B7B',
                fontSize: 14
              }}
            >
              Preview
            </span>
          </div>
        )}
      </Col>
      <Col md={3}>
        <Button
          type="button"
          color="#7367F0"
          style={{
            background: '#7367F0',
            padding: 10
          }}
          onClick={() => handleDelete(`${idx}_video`)}
        >
          <XCircle
            enableBackground="#7367F0"
            fill="#7367F0"
            color="white"
            style={{
              cursor: 'pointer'
            }}
          />
        </Button>
      </Col>
    </Row>
  );
};

const AudioComponent = ({ content, idx, handleDelete, handleOnChange }) => {
  const [audio, setAudio] = useState(content || '');  
  const [progress, setProgress] = useState({
    per: 0,
    text: '0%',
    started: false
  });
 

  const handleFileUpload = async (files) => {
    try {
      const data = new FormData();
      data.append('file', files[0]);
      const config = {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          const text = `${percentCompleted}%`;
          setProgress({
            per: percentCompleted,
            text,
            started: true
          });
        }
      };
      const res = (await api.post('/roads/file-upload', data, config)).data;
      setAudio(res.uri);
      handleOnChange(`${idx}_audio`, {
        content: res.uri,
        type: 'audio'
      });
     
    } catch (e) {}
  };  

  useEffect(() => {
    setAudio(content);
  }, [content]);

  return (
    <Row className="mb-2">
     
        <Col>
          <FileUploaderSingle
            handleSubmit={handleFileUpload}
            accept=".mp3"
            autosubmit={true}
          >
            <>
              <Label className="form-label fs-6 mb-1" for="cover">
                Sube un audio mp3
              </Label>
              <div
                className="px-5 py-2 d-flex align-items-center justify-content-center flex-column"
                style={{
                  border: '1px dashed #7367F0',
                  borderRadius: '2.5px'
                }}
              >
                <DownloadCloud size={64} />
                <p className="text-secondary">
                  Suelta archivos aca o{' '}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    navega
                  </a>
                </p>
                {progress.started && (
                  <div
                    className="progress"
                    style={{ width: '100%', height: 15, bottom: 0 }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        background: '#4DFF84',
                        width: `${progress.text}`
                      }}
                      aria-valuenow={progress.per}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      {progress.text}
                    </div>
                  </div>
                )}
              </div>
            </>
          </FileUploaderSingle>          
        </Col>
     
      {audio !== '' ? (
        <Col md={4}>
          <div className="d-flex">
            <div className="me-25">
              <audio
               className="position-relative mt-3"
                src={audio}
                alt="Generic placeholder audio"
                height="250"
                width="250"
                controls
              />                      
            </div>
          </div>
        </Col>
      ) : (
        <Col md={4}>
          <div
            style={{
              width: 366,
              height: 100,
              background: '#F7F7F7'
            }}
            className="position-relative mt-3"
          >
            <span
              className="position-absolute fw-bolder top-50 start-50 translate-middle"
              style={{
                color: '#6D6B7B',
                fontSize: 14
              }}
            >
              Preview
            </span>
          </div>
        </Col>
      )}{' '}
      <Col md={3}>
        <Button
          type="button"
          color="#7367F0"
          style={{
            background: '#7367F0',
            padding: 10
          }}
          onClick={() => handleDelete(`${idx}_audio`)}
        >
          <XCircle
            enableBackground="#7367F0"
            fill="#7367F0"
            color="white"
            style={{
              cursor: 'pointer'
            }}
          />
        </Button>
      </Col>
    </Row>
  );
};

const ContentCreator = ({ stepper, handleOnSubmit, defaultValues }) => {
  const [data, setData] = useState([]);

  const onSubmit = () => {
    handleOnSubmit({ contents: data });
    stepper.next();
  };

  const handleSave = useCallback(
    (newData) => {
      _data.clear();
      newData.forEach((q, idx) => {
        const item = {
          ...q,
          __typename: undefined
        };
        _data.set(`${idx}_${q.type}`, item);
        return item;
      });
      setData([..._data.values()]);
    },
    [_data]
  );

  const handleDelete = (id) => {
    _data.delete(id);
    const val = [..._data.values()];
    handleSave(val);
  };

  const handleCreateItem = (type) => {
    handleSave([
      ..._data.values(),
      {
        type,
        content: ''
      }
    ]);
  };

  const handleOnChange = (id, item) => {
    _data.set(id, item);
    handleSave([..._data.values()]);
  };

  useEffect(() => {
    handleSave(defaultValues.contents || []);
  }, [handleSave]);

  return (
    <>
      <div className="content-header">
        <h5 className="mb-0">Cargar Contenido</h5>
        <small className="text-muted">Crear el contenido del episodio</small>
      </div>
      {data.map((item, idx) => {
        if (item.type === 'html') {
          return (
            <EditorComponent
              key={`${idx}_${item.type}`}
              content={item.content}
              idx={idx}
              handleDelete={handleDelete}
              handleOnChange={handleOnChange}
            />
          );
        } else if (item.type === 'video') {
          return (
            <VideoComponent
              key={`${idx}_${item.type}`}
              content={item.content}
              idx={idx}
              handleDelete={handleDelete}
              handleOnChange={handleOnChange}
            />
          );
        } else if (item.type === 'audio') {
          return (
            <AudioComponent
              key={`${idx}_${item.type}`}
              content={item.content}
              idx={idx}
              handleDelete={handleDelete}
              handleOnChange={handleOnChange}
            />
          );
        }
      })}

      <Row className="mb-5">
        <Col md="6">
          <Button
            color="primary"
            className="mx-2"
            onClick={() => handleCreateItem('video')}
          >
            Insertar Video
          </Button>

          <Button color="primary" className="mx-2" onClick={() => handleCreateItem('html')}>
            Insertar Texto
          </Button>

          <Button color="primary" onClick={() => handleCreateItem('audio')}>
            Insertar Audio
          </Button>
        </Col>
      </Row>
      <div className="d-flex justify-content-between">
        <Button
          type="button"
          color="secondary"
          className="btn-prev"
          outline
          onClick={() => {
            stepper.previous();
          }}
        >
          <ArrowLeft size={14} className="align-middle me-sm-25 me-0" />{' '}
          <span className="align-middle d-sm-inline-block d-none">
            Previous
          </span>
        </Button>
        <Button
          type="submit"
          color="primary"
          className="btn-next"
          onClick={() => onSubmit()}
        >
          <span className="align-middle d-sm-inline-block d-none">
            Siguiente
          </span>
          <ArrowRight size={14} className="align-middle ms-sm-25 ms-0" />
        </Button>
      </div>
    </>
  );
};

export default ContentCreator;
